<div class="modal-header">
    <h3 class="modal-title">Manage My Hotlist</h3>
</div>
<div class="modal-body" style="overflow: auto;max-height: 500px;">
    <div class="col-lg-4 col-md-6 col-sm-6 col-12" style="float: left;"
         *ngFor="let category of data; let i = index">
        <div class="d-flex flex-column">
            <h4>{{category.CategoryName}}</h4>
            <ng-container *ngFor="let modules of category | keyvalue:keepOriginalOrder">
                <hr style="width:75%;"
                    *ngIf="modules.key != 'CategoryName' && modules.key != 0" />
                <label *ngIf="modules.key != 'CategoryName' && modules.key != 0">{{modules.value[0].ModuleSubCatgName}}</label>
                <ul style="list-style: none; padding-left: 0;"
                    *ngIf="modules.key != 'CategoryName'">
                    <li *ngFor="let module of modules.value" style="display:flex;margin-top:5px;">
                        <ng-container *ngIf="module.ModuleShowInNav">
                            <input type="checkbox" style="width:20px;height:20px;"
                                   [(ngModel)]="module.IsHotlistItem"
                                   (ngModelChange)="updateHotlistItem(module)" />
                            <a [href]="module.ModuleActionName" *ngIf="!module.ModuleOpenNewWindow" style="margin-left:3px;">{{module.ModulePrettyTitle}}</a>
                            <a [href]="module.ModuleActionName" target="_blank" *ngIf="module.ModuleOpenNewWindow" style="margin-left:3px;">{{module.ModulePrettyTitle}}</a>
                        </ng-container>
                    </li>
                </ul>
            </ng-container>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="closeClicked()">Close</button>
</div>